import React, { useState } from 'react';
import './style.scss';
import MainBackgroundWrapper from '../../../components/mainBackgroundWrapper';
import Button from '../../../components/controls/button';

interface Props {
  logout: () => void;
  verifyId: (stopLoading: () => any) => void;
  logoutLoading: boolean;
}

const InvalidTokenBlock = ({ logout, verifyId, logoutLoading }: Props) => {
  const [refreshLoading, setRefreshLoading] = useState(false);

  const handleRefreshClick = () => {
    setRefreshLoading(true);
    verifyId(() => setRefreshLoading(false));
  };

  return (
    <MainBackgroundWrapper mode='center'>
      <h1>Invalid Token</h1>
      <h4 className='invalid-token-subheader'>(Or either server is down)</h4>
      <div className='invalid-token-buttons'>
        <Button onClick={handleRefreshClick} loading={refreshLoading}>
          Check Again
        </Button>
        <Button
          onClick={() => logout()}
          loading={logoutLoading}
          color='secondary'
        >
          Logout
        </Button>
      </div>
    </MainBackgroundWrapper>
  );
};

export default InvalidTokenBlock;
